import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=4ba13b76"
import script from "./CustomTable.vue?vue&type=script&lang=ts"
export * from "./CustomTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=4ba13b76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports